// extracted by mini-css-extract-plugin
export default {"heading":"zn-z","createAccount":"An-z","disabled":"Bn-z","copy":"Cn-z","terms":"Dn-z"};